import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from '../Apiurl';

function ForzaSync({
    idProd,
    codVS,
    codPS,
    trad,
    setProductFunction,
    cambiaStato,
    utente
}) {

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const nomeUtente = utente.username;

    let aspetto = {
        classe: "",
        testo: "",
        funzione: ""
    }

    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);

    function forzaSync() {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                idProd: idProd,
                utente: utente,
                codVS: codVS,
                codPS: codPS
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/prodotti/ps/forzaSyncProdottoSingolo", data, config)
            .then(data => {
                cambiaStato();
            })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }


    if (trad) {
        aspetto = {
            ...aspetto,
            classe: "material-icons md-13 tastiVicinoInput button-reset tooltip border-box white tastoVerde bn br3 pointer bordoColScrittaDef-10  bordoColScrittaDef-10",
            testo: "done",
            funzione: ()=>{}
        }
    } else {
        aspetto = {
            ...aspetto,
            classe: " tastiVicinoInput button-reset tooltip border-box white tastoArancio bn br3 pointer bordoColScrittaDef-10  bordoColScrittaDef-10",
            testo: "forzaSync",
            funzione: forzaSync
        }
    }

    return(
        <div>
            <button 
            className={aspetto.classe}
            onClick={aspetto.funzione}
            >
            {aspetto.testo}
            </button>   
            </div>
    )
        
        
}


export default ForzaSync;



